import React, { useState, useEffect } from 'react';
import BackgroundMedia from '../components/BackgroundMedia';
import Navbar from '../components/Navbar';
import MenuOverlay from '../components/MenuOverlay';

const Home = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
      console.log('Menu opened');
    } else {
      document.body.style.overflow = 'hidden';
      console.log('Menu closed');
    }
  }, [isMenuOpen]);

  const handleMenuOpen = () => {
    console.log('handleMenuOpen called');
    setIsMenuOpen(true);
  };

  const handleMenuClose = () => {
    console.log('handleMenuClose called');
    setIsMenuOpen(false);
  };

  console.log('Home render, isMenuOpen:', isMenuOpen);

  return (
    <>
      <BackgroundMedia
        type="image"
        src="/images/main-page.jpg"
        mobileSrc="/images/JJG00283.jpg"
        alt="Dramatic black and white sports photography"
      >
        <Navbar onMenuClick={handleMenuOpen} />
      </BackgroundMedia>

      <MenuOverlay isOpen={isMenuOpen} onClose={handleMenuClose} />
    </>
  );
};

export default Home;
